import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ModalContainer } from '../../../common';
import { ActionButton } from '../../../common/petCloud';

import exclamationIcon
  from '../../../../assets/billingPayments/exclamation-red.svg';

import { reimbursementMethodErrorCleared } from '../../../../actions';
import { useCareCreditCardSubmit } from './hooks/useCareCreditCardSubmit';

import styles from './ReimbursementMethodErrorModal.module.css';

export const ReimbursementMethodErrorModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('myAccount');

  const { onSubmitCareCredit, loading } = useCareCreditCardSubmit();

  const onModalDismiss = useCallback(() => {
    if (loading) {
      return;
    }

    dispatch(reimbursementMethodErrorCleared());
  }, [loading, dispatch]);

  const onTryAgainClick = useCallback(() => {
    if (loading) {
      return;
    }

    onSubmitCareCredit();
  }, [loading, onSubmitCareCredit]);

  return (
    <ModalContainer cancelable handleOutClick={onModalDismiss} show>
      <div className={styles.mainContainer}>
        <img alt="" src={exclamationIcon} />

        <h1>{t('reimbursementSection.errorModal.title')}</h1>

        <p>{t('reimbursementSection.errorModal.description')}</p>

        <div className={styles.buttonsContainer}>
          <ActionButton
            isSecondaryButton
            onClick={onModalDismiss}
            title={t('reimbursementSection.errorModal.goBackButton')}
          />

          <ActionButton
            loading={loading}
            onClick={onTryAgainClick}
            title={t('reimbursementSection.errorModal.tryAgainButton')}
          />
        </div>
      </div>
    </ModalContainer>
  );
};
